import { render, staticRenderFns } from "./DashboardFooter.vue?vue&type=template&id=2b0c83fa&"
import script from "./DashboardFooter.vue?vue&type=script&lang=js&"
export * from "./DashboardFooter.vue?vue&type=script&lang=js&"
import style0 from "./DashboardFooter.vue?vue&type=style&index=0&id=2b0c83fa&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports